// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-group label {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    padding: 8px 0;
    position: relative;
}

.radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
}

.radio-group input[type="radio"] + label:before {
    content: '';
    background: #f4f4f4;
    border-radius: 100%;
    border: 1px solid #bdbdbd;
    display: inline-block;
    flex-shrink: 0;
    width: 1.4em;
    height: 1.4em;
    position: relative;
    top: 0.1em;
    margin-right: 1em;
    cursor: pointer;
    text-align: center;
    transition: all 250ms ease;
}

.radio-group input[type="radio"]:checked + label:before {
    background-color: #3197EE;
    box-shadow: inset 0 0 0 4px #f4f4f4;
}

.radio-group input[type="radio"]:focus + label:before {
    outline: none;
    border-color: #3197EE;
}

.radio-group input[type="radio"]:disabled + label {
    cursor: not-allowed;
    color: #999;
}

.radio-group input[type="radio"]:disabled + label:before {
    box-shadow: inset 0 0 0 4px #f4f4f4;
    border-color: #bdbdbd;
    background: #bdbdbd;
    cursor: not-allowed;
}

/* Keep selected radio button blue when disabled */
.radio-group input[type="radio"]:checked:disabled + label {
    color: #333;
}

.radio-group input[type="radio"]:checked:disabled + label:before {
    background-color: #3197EE;
    border-color: #3197EE;
    box-shadow: inset 0 0 0 4px #f4f4f4;
}

.egyeb-editor-container {
    margin-top: 10px;
    margin-left: 0;
}

/* Checkbox styles matching radio buttons */
.szakjelentes-create-wrapper .checkbox-group {
    display: block;
    margin: 0;
}

.checkbox-group label {
    display: inline-block;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    padding: 8px 0;
    position: relative;
}

.checkbox-group input[type="checkbox"] {
    position: absolute;
    opacity: 0;
}

.checkbox-group input[type="checkbox"] + label:before {
    content: '';
    background: #f4f4f4;
    border-radius: 3px;
    border: 1px solid #bdbdbd;
    display: inline-block;
    width: 1.4em;
    height: 1.4em;
    position: relative;
    bottom: 0.15em;
    margin-right: 1em;
    vertical-align: middle;
    cursor: pointer;
    text-align: center;
    transition: all 250ms ease;
}

.checkbox-group input[type="checkbox"]:checked + label:before {
    background-color: #3197EE;
    box-shadow: inset 0 0 0 4px #f4f4f4;
}

.checkbox-group input[type="checkbox"]:focus + label:before {
    outline: none;
    border-color: #3197EE;
}

.checkbox-group input[type="checkbox"]:disabled + label {
    cursor: not-allowed;
    color: #999;
}

.checkbox-group input[type="checkbox"]:disabled + label:before {
    box-shadow: inset 0 0 0 4px #f4f4f4;
    border-color: #bdbdbd;
    background: #bdbdbd;
    cursor: not-allowed;
}

/* Keep selected checkbox blue when disabled */
.checkbox-group input[type="checkbox"]:checked:disabled + label {
    color: #333;
}

.checkbox-group input[type="checkbox"]:checked:disabled + label:before {
    background-color: #3197EE;
    border-color: #3197EE;
    box-shadow: inset 0 0 0 4px #f4f4f4;
}
`, "",{"version":3,"sources":["webpack://./src/components/szakjelentesCreate/RadioButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,kDAAkD;AAClD;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mCAAmC;AACvC","sourcesContent":[".radio-group label {\n    display: flex;\n    align-items: flex-start;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n    padding: 8px 0;\n    position: relative;\n}\n\n.radio-group input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n}\n\n.radio-group input[type=\"radio\"] + label:before {\n    content: '';\n    background: #f4f4f4;\n    border-radius: 100%;\n    border: 1px solid #bdbdbd;\n    display: inline-block;\n    flex-shrink: 0;\n    width: 1.4em;\n    height: 1.4em;\n    position: relative;\n    top: 0.1em;\n    margin-right: 1em;\n    cursor: pointer;\n    text-align: center;\n    transition: all 250ms ease;\n}\n\n.radio-group input[type=\"radio\"]:checked + label:before {\n    background-color: #3197EE;\n    box-shadow: inset 0 0 0 4px #f4f4f4;\n}\n\n.radio-group input[type=\"radio\"]:focus + label:before {\n    outline: none;\n    border-color: #3197EE;\n}\n\n.radio-group input[type=\"radio\"]:disabled + label {\n    cursor: not-allowed;\n    color: #999;\n}\n\n.radio-group input[type=\"radio\"]:disabled + label:before {\n    box-shadow: inset 0 0 0 4px #f4f4f4;\n    border-color: #bdbdbd;\n    background: #bdbdbd;\n    cursor: not-allowed;\n}\n\n/* Keep selected radio button blue when disabled */\n.radio-group input[type=\"radio\"]:checked:disabled + label {\n    color: #333;\n}\n\n.radio-group input[type=\"radio\"]:checked:disabled + label:before {\n    background-color: #3197EE;\n    border-color: #3197EE;\n    box-shadow: inset 0 0 0 4px #f4f4f4;\n}\n\n.egyeb-editor-container {\n    margin-top: 10px;\n    margin-left: 0;\n}\n\n/* Checkbox styles matching radio buttons */\n.szakjelentes-create-wrapper .checkbox-group {\n    display: block;\n    margin: 0;\n}\n\n.checkbox-group label {\n    display: inline-block;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n    padding: 8px 0;\n    position: relative;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n    position: absolute;\n    opacity: 0;\n}\n\n.checkbox-group input[type=\"checkbox\"] + label:before {\n    content: '';\n    background: #f4f4f4;\n    border-radius: 3px;\n    border: 1px solid #bdbdbd;\n    display: inline-block;\n    width: 1.4em;\n    height: 1.4em;\n    position: relative;\n    bottom: 0.15em;\n    margin-right: 1em;\n    vertical-align: middle;\n    cursor: pointer;\n    text-align: center;\n    transition: all 250ms ease;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked + label:before {\n    background-color: #3197EE;\n    box-shadow: inset 0 0 0 4px #f4f4f4;\n}\n\n.checkbox-group input[type=\"checkbox\"]:focus + label:before {\n    outline: none;\n    border-color: #3197EE;\n}\n\n.checkbox-group input[type=\"checkbox\"]:disabled + label {\n    cursor: not-allowed;\n    color: #999;\n}\n\n.checkbox-group input[type=\"checkbox\"]:disabled + label:before {\n    box-shadow: inset 0 0 0 4px #f4f4f4;\n    border-color: #bdbdbd;\n    background: #bdbdbd;\n    cursor: not-allowed;\n}\n\n/* Keep selected checkbox blue when disabled */\n.checkbox-group input[type=\"checkbox\"]:checked:disabled + label {\n    color: #333;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked:disabled + label:before {\n    background-color: #3197EE;\n    border-color: #3197EE;\n    box-shadow: inset 0 0 0 4px #f4f4f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
